import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1583165209654263'
let initialized = false

function firePixelImage(eventName: string, params?: Record<string, string>) {
  try {
    const img = new Image(1, 1)
    let paramStr = ''
    if (params) {
      paramStr = Object.entries(params)
        .map(
          ([k, v]) => `&cd[${encodeURIComponent(k)}]=${encodeURIComponent(v)}`,
        )
        .join('')
    }
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${encodeURIComponent(eventName)}${paramStr}&noscript=1&t=${Date.now()}`
  } catch (e) {
    // Silently fail
  }
}

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    // Create fbq queue function before script loads
    if (!window.fbq) {
      const fbq = function () {
        fbq.callMethod
          ? fbq.callMethod.apply(fbq, arguments)
          : fbq.queue.push(arguments)
      } as any
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq
      if (!window._fbq) window._fbq = fbq
    }

    // Load the Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onerror = () => {
      // Script blocked — image fallbacks will handle tracking
    }
    document.head.appendChild(script)

    // Init and fire PageView via SDK
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (e) {
    // Silently fail
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  try {
    // Fire via fbq SDK
    if (window.fbq) {
      window.fbq('track', eventName, params)
    }
  } catch (e) {
    // Silently fail
  }

  // Fire via direct image pixel as fallback
  const stringParams: Record<string, string> = {}
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      stringParams[k] = String(v)
    })
  }
  firePixelImage(eventName, stringParams)
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
